import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TCustomerFormValidCnpjOrCpfService = {
  payload: {
    cnpjOrCpf: string
  }
}

export const customerFormValidCnpjOrCpfService = async ({
  payload,
}: TCustomerFormValidCnpjOrCpfService): Promise<ResponseAPI> => {
  const response = await api.get(`verificarcliente/${payload.cnpjOrCpf}`)

  return response.data
}
